import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { ecosystem } from '@/mocks/about';

export default function Ecosystem() {
  return (
    <section id="ecosystem" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            title="1+3 服务商联合体"
            en="Partner Ecosystem"
            subtitle="华辉数智与多方合作伙伴形成分工协作体系，共同推进九畴云市乡村数字经济服务体系建设。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {ecosystem.map((item, i) => (
            <Reveal key={item.name} delay={i * 80}>
              <div
                className={`h-full p-5 rounded-lg border text-center ${
                  item.highlight
                    ? 'bg-primary-500 text-background-50 border-primary-500'
                    : 'bg-background-50 border-background-200'
                }`}
              >
                <div
                  className={`w-11 h-11 mx-auto rounded-full flex items-center justify-center ${
                    item.highlight ? 'bg-background-50/20' : 'bg-primary-100'
                  }`}
                >
                  <i
                    className={`ri-building-2-line text-xl ${
                      item.highlight ? 'text-background-50' : 'text-primary-600'
                    }`}
                  ></i>
                </div>
                <h3
                  className={`mt-3 font-heading font-bold text-sm ${
                    item.highlight ? 'text-background-50' : 'text-foreground-950'
                  }`}
                >
                  {item.name}
                </h3>
                <p
                  className={`mt-1 text-xs leading-relaxed ${
                    item.highlight ? 'text-background-100' : 'text-foreground-500'
                  }`}
                >
                  {item.role}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <p className="mt-8 text-center text-sm text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            慈商科技、三明词元、华辉数智、纽盾科技、欣阳通力等形成「1+3」服务商联合体，并进一步组建人工智能应用服务团，形成分工协作的产业生态体系。
          </p>
        </Reveal>
      </div>
    </section>
  );
}